// extracted by mini-css-extract-plugin
export default {"wrapper":"Product_wrapper__wM+8n","info":"Product_info__yvQK0","img-wrapper":"Product_img-wrapper__FaPNc","name":"Product_name__eZ+S+","img":"Product_img__07jNe"};